export default __webpack_public_path__ + "static/media/add.2954a0dc.svg";